import React, { useEffect, useState } from "react";
// import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../context/AlertContext";
import { useLoading } from "context/LoadingContext";
import { fetchGRNStatusData } from "../Service/ApiService";
import { Stairs } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

// const schema = Yup.object().shape({
//   userCode: Yup.string()
//     .required("User code is required")
//     .matches(/^\d+$/, "User code must contain only numbers")
//     .length(6, "User code must be exactly 6 characters"),
//   password: Yup.string().required("Password is required"),
// });

const GRNStatusController = () => {
  const vendordetails = JSON.parse(localStorage.getItem("vendor"));
  const vendorCode = vendordetails ? vendordetails.vendorCode : null;

  const [rows, setRows] = useState([]);
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 100 });
  const [rowCount, setRowCount] = useState(0);
  const [poNumber, setPONumber] = useState(localStorage.getItem("poNumbergn") || "");

  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const { showAlert } = useAlert();

  useEffect(() => {
    getGRNStatusData();
  }, [paginationModel, poNumber]);

  // Navigate function (reusable)
  const handleNavigate = (row) => {
    localStorage.setItem("poNumbergn", poNumber);
    navigate("/staging", {
      state: {
        PONumber: row.purchase_order_no,
        PODate: row.po_date,
        totalQuantity: row.order_quantity,
      },
    });
  };

  // 🧭 Columns with icon next to PO No.
  const columns = [
    {
      field: "purchase_order_no",
      headerName: "PO No.",
      flex: 1,
      minWidth: 150,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            overflow: "visible",
          }}
        >
          {/* <span
            onClick={() => handleNavigate(params.row)}
            style={{
              color: "#1976d2",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            {params.row.purchase_order_no}
          </span> */}

          <Tooltip title={`View Staging`}>
            <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              {params.row.purchase_order_no}
              <IconButton
                size="small"
                color="info"
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigate(params.row);
                }}
                style={{ padding: "2px" }}
              >
                <Stairs fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        </div>
      ),
    },
    {
      field: "po_date",
      headerName: "PO Date",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "material_code",
      headerName: "Material Code",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "material_group_desc",
      headerName: "Material Group Description",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "order_quantity",
      headerName: "Ordered Quantity",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "balance_quantity",
      headerName: "Balance Quantity",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "gr_amt",
      headerName: "GR Amount",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "first_grn_no",
      headerName: "First GRN No.",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "first_grn_date",
      headerName: "First GRN Date",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "last_grn_no",
      headerName: "Last GRN No.",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "last_grn_date",
      headerName: "Last GRN Date",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
  ];

  const getGRNStatusData = async () => {
    try {
      setLoading(true);
      const response = await fetchGRNStatusData(
        vendorCode,
        poNumber,
        paginationModel.page + 1,
        paginationModel.pageSize
      );

      if (response && response.status === "success") {
        setRows(response.data);
        setRowCount(response.totalRows || 0);
      } else {
        showAlert("Something went wrong while showing GRN status data!");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showAlert("Something went wrong while showing GRN status data!");
    }
  };

  return {
    columns,
    rows,
    paginationModel,
    setPaginationModel,
    rowCount,
    poNumber,
    setPONumber,
  };
};

export default GRNStatusController;
